module.exports = __webpack_public_path__ + "img/buscar.b8721b9f.png";